function initCarousel(options) {
    function CustomCarousel(options) {
        this.init(options);
        this.addListeners();
        return this;
    }

    CustomCarousel.prototype.init = function (options) {
        this.node = options.node;
        this.node.slider = this;
        this.pagination = this.node.querySelector('.pagination');
        this.pagTransf = 'translate( -50%, -50% )';
        this.dots = this.pagination.children;
        this.dotsN = this.dots.length;
        this.angleSpacing = 120;
        this.startAngle = 270;
        this.step = -this.angleSpacing / this.dotsN;
        this.activeN = options.activeN || Math.floor(this.dotsN / 2);
        this.prevN = this.activeN;
        this.speed = options.speed || 200;
        this.autoplay = options.autoplay || false;
        this.autoplayId = null;
        
        // Find next and prev buttons
        const carouselContent = this.node.parentElement.querySelector('.carousel-section-content');
        this.next = carouselContent.querySelector('.next');
        this.prev = carouselContent.querySelector('.prev');
        
        // Get the index display element
        this.indexDisplay = this.node.parentElement.querySelector('.product-carousel-index');
        
        // Set initial angle to position active item at top (0 degrees)
        const activeItemAngle = this.startAngle + (this.angleSpacing / this.dotsN * this.activeN);
        this.angle = -activeItemAngle;
        
        // Apply initial rotation immediately
        this.pagination.style.transform = this.pagTransf + 'rotate(' + this.angle + 'deg)';
        
        // Then arrange dots and position content
        this.arrangeDots();
        this.setInitialContent();
        
        // Add transition after initial positioning is complete
        setTimeout(() => {
            this.pagination.style.transitionDuration = this.speed + 'ms';
            if (this.autoplay) this.startAutoplay();
            
            // Show all elements after arrangement
            this.showCarouselElements();
        }, 50);
        
        this.initialized = true;
    }

    CustomCarousel.prototype.showCarouselElements = function() {
        // Show pagination
        this.pagination.style.opacity = '1';
        
        // Show all dots
        for (var i = 0; i < this.dotsN; i++) {
            this.dots[i].querySelector('.dot').style.opacity = '1';
        }
        
        // Show content section
        const carouselContent = this.node.parentElement.querySelector('.carousel-section-content');
        carouselContent.style.opacity = '1';
    };

    CustomCarousel.prototype.addListeners = function () {
        var slider = this;

        if (this.next) {
            this.next.addEventListener('click', function () {
                slider.stopAutoplay();
                slider.setSlide(slider.activeN + 1);
            });
        }
        if (this.prev) {
            this.prev.addEventListener('click', function () {
                slider.stopAutoplay();
                slider.setSlide(slider.activeN - 1);
            });
        }

        for (var i = 0; i < this.dots.length; i++) {
            this.dots[i].addEventListener('click', function (i) {
                return function () {
                    // Check if this is already the active slide
                    if (i === slider.activeN) {
                        // Redirect to product page
                        const template = slider.dots[i].querySelector('template');
                        if (template) {
                            const productUrl = template.content.querySelector('[data-product-url]').getAttribute('data-product-url');
                            if (productUrl) {
                                window.location.href = productUrl;
                            }
                        }
                    } else {
                        // Otherwise just navigate to that slide
                        slider.stopAutoplay();
                        slider.setSlide(i);
                    }
                }
            }(i));
        }
    };

    CustomCarousel.prototype.setSlide = function (slideN) {
        if (this.contentTimeout) {
            clearTimeout(this.contentTimeout);
        }

        if (this.dots[this.activeN]) this.dots[this.activeN].classList.remove('active');

        this.prevN = this.activeN;
        
        if (slideN < 0) {
            slideN = 0;
        } else if (slideN >= this.dotsN) {
            slideN = this.dotsN - 1;
        }
        
        this.activeN = slideN;
        
        this.updateButtonStates();
        
        // Update the product index display
        if (this.indexDisplay) {
            setTimeout(() => {
                this.indexDisplay.textContent = this.activeN + 1;
            }, 300);
        }

        if (this.dots[this.activeN]) {
            this.dots[this.activeN].classList.toggle('active');

            const template = this.dots[this.activeN].querySelector('template');
            if (template) {
                const productCard = this.node.parentElement.querySelector('.product-card');
                
                if (this.initialized) {
                    const product__title__el = productCard.querySelector(".product-title");
                    const product__title__content = template.content.querySelector(".product-title").textContent;
                    const product__desc__el = productCard.querySelector(".product-description");
                    const product__desc__content = template.content.querySelector(".product-description").textContent;
                    const product__price__el = productCard.querySelector(".product-price");
                    const product__price__content = template.content.querySelector(".product-price").textContent;
                    const variantId = template.content.querySelector(".product-id").textContent;
                    const productUrl = template.content.querySelector("[data-product-url]").getAttribute("data-product-url");

                    this.contentTimeout = setTimeout(() => {
                        product__title__el.textContent = product__title__content;
                        product__desc__el.textContent = product__desc__content;
                        product__price__el.textContent = product__price__content;
                        productCard.setAttribute('data-variant-id', variantId);
                        // keep add-to-cart button variant in sync with current slide
                        const atcBtn = productCard.querySelector('[data-add-to-cart]');
                        if (atcBtn) {
                            atcBtn.setAttribute('data-variant-id', variantId);
                        }
                        // Update the product URL in the product title link
                        if (productUrl) {
                            product__title__el.href = productUrl;
                        }
                    }, 300);
                }
            }
        }

        this.rotateToActiveItem();
    };

    CustomCarousel.prototype.updateButtonStates = function() {
        if (this.prev) {
            if (this.activeN <= 0) {
                this.prev.disabled = true;
                this.prev.classList.add('disabled');
            } else {
                this.prev.disabled = false;
                this.prev.classList.remove('disabled');
            }
        }
        
        if (this.next) {
            if (this.activeN >= this.dotsN - 1) {
                this.next.disabled = true;
                this.next.classList.add('disabled');
            } else {
                this.next.disabled = false;
                this.next.classList.remove('disabled');
            }
        }
    };

    CustomCarousel.prototype.rotateToActiveItem = function() {
        const activeItemAngle = this.startAngle + (this.angleSpacing / this.dotsN * this.activeN);
        this.angle = -activeItemAngle;
        
        this.pagination.style.transform = this.pagTransf + 'rotate(' + this.angle + 'deg)';
        this.arrangeDots2(this.angle);
    };

    CustomCarousel.prototype.startAutoplay = function () {
        var slider = this;

        this.autoplayId = setInterval(function () {
            slider.setSlide(slider.activeN + 1);
        }, this.autoplay);
    };

    CustomCarousel.prototype.stopAutoplay = function () {
        clearInterval(this.autoplayId);
    };

    CustomCarousel.prototype.arrangeDots = function () {
        for (var i = 0; i < this.dotsN; i++) {
            const dotsRotateAngle = this.startAngle + (this.angleSpacing / this.dotsN * i);
            const currentDotItem = this.dots[i];
            currentDotItem.style.transform = 'rotate(' + dotsRotateAngle + 'deg)';
            
            // Apply correct initial rotation to each dot
            if (i === this.activeN) {
                // Special styling for active dot
                currentDotItem.children[0].style.transform = 'translate(-50%, -50%) rotate(0deg) scale(1.2)';
                currentDotItem.children[0].style.zIndex = '10';
            } else {
                // Calculate the correct angle based on the initial rotation
                const finalRotation = -dotsRotateAngle - this.angle;
                currentDotItem.children[0].style.transform = 'translate(-50%, -50%) rotate(' + finalRotation + 'deg)';
            }
        }
    };

    CustomCarousel.prototype.arrangeDots2 = function (rotationAngle) {
        if (this.initialized !== true) return;
        for (var i = 0; i < this.dotsN; i++) {
            const baseAngle = this.startAngle + (this.angleSpacing / this.dotsN * i);
            const finalAngle = baseAngle + rotationAngle;
            const currentDotItem = this.dots[i];
            currentDotItem.children[0].style.transition = 'transform ' + this.speed + 'ms';
            
            if (i === this.activeN) {
                // Keep scale for active item
                currentDotItem.children[0].style.transform = 'translate(-50%, -50%) rotate(' + -finalAngle + 'deg) scale(1.2)';
            } else {
                currentDotItem.children[0].style.transform = 'translate(-50%, -50%) rotate(' + -finalAngle + 'deg)';
            }
        }
    };

    // New method to set initial content without animation
    CustomCarousel.prototype.setInitialContent = function() {
        if (this.dots[this.activeN]) {
            this.dots[this.activeN].classList.add('active');
            
            // Update the index display with initial value
            if (this.indexDisplay) {
                this.indexDisplay.textContent = this.activeN + 1;
            }
            
            const template = this.dots[this.activeN].querySelector('template');
            if (template) {
                const productCard = this.node.parentElement.querySelector('.product-card');
                const product__title__el = productCard.querySelector('.product-title');
                product__title__el.textContent = template.content.querySelector('.product-title').textContent;
                productCard.querySelector('.product-description').textContent = template.content.querySelector('.product-description').textContent;
                productCard.querySelector('.product-price').textContent = template.content.querySelector('.product-price').textContent;
                const initialVariantId = template.content.querySelector('.product-id').textContent;
                productCard.setAttribute('data-variant-id', initialVariantId);
                // keep add-to-cart button variant in sync on initial render
                const atcBtn = productCard.querySelector('[data-add-to-cart]');
                if (atcBtn) {
                    atcBtn.setAttribute('data-variant-id', initialVariantId);
                }
                
                // Set the product URL
                const productUrl = template.content.querySelector('[data-product-url]').getAttribute('data-product-url');
                if (productUrl) {
                    product__title__el.href = productUrl;
                }
                
                productCard.style.opacity = '1';
            }
        }
        
        this.updateButtonStates();
    }

    return new CustomCarousel(options);
}

var plugins = {
    customCarousel: document.querySelectorAll('.product-carousel')
}

document.addEventListener('DOMContentLoaded', function () {
    if (plugins.customCarousel.length) {
        for (var i = 0; i < plugins.customCarousel.length; i++) {
            var carousel = initCarousel({
                node: plugins.customCarousel[i],
                speed: plugins.customCarousel[i].getAttribute('data-speed'),
                autoplay: plugins.customCarousel[i].getAttribute('data-autoplay')
            });
        }
    }
});